export const ist = {
    MixDiagrammEinnahmenClass: {
        url: "Diagramm/einnahmenbar",
        defaultSegment: "Diagramm",
        forceRefresh: false,
        receiveType: 'RECEIVE_MixDiagrammEinnahmen_einnahmenReducer'
    }
};